import React from 'react'
import { Line } from 'src/components/helpers/line'
import { i18n } from 'next-i18next'

const FootPrintUserChart = ({ data }) => {
  const config = {
    data,
    xField: 'month',
    yField: 'co2_amount',
    seriesField: 'footprint',
    smooth: true
  }

  const getChartHeigth = () => {
    const lang = i18n?.language
    return lang === 'es' ? '272px' : '252px'
  }

  return (
    <Line
      {...config}
      style={{ height: getChartHeigth() }}
    />
  )
}

export default FootPrintUserChart
